import { motion, useReducedMotion } from "framer-motion";

export default function DoodleUnderline({ className }: { className?: string }) {
  const reduce = useReducedMotion();
  return (
    <svg
      viewBox="0 0 200 12"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <motion.path
        d="M3 8 C40 2 70 12 100 6 C130 1 165 10 197 4"
        fill="none"
        stroke="currentColor"
        strokeWidth={6}
        strokeLinecap="round"
        initial={reduce ? undefined : { pathLength: 0 }}
        animate={reduce ? undefined : { pathLength: 1 }}
        transition={reduce ? undefined : { duration: 0.7, delay: 0.15, ease: "easeInOut" }}
      />
    </svg>
  );
}
